var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 69,
    viewBox: "0 0 49 69",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.89457 59.8517L0.556641 68.3023H7.59879L9.71143 65.4854H39.2884L41.4011 68.3023H48.4432L42.1053 59.8517H6.89457Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.96507 36.1901V6.33141H16.0494V3.51455C16.0494 1.95886 17.3105 0.697693 18.8662 0.697693H30.1337C31.6894 0.697693 32.9505 1.95886 32.9505 3.51455V6.33141H47.0348V36.1901C47.0348 42.5004 47.0348 45.6556 45.8067 48.066C44.7264 50.186 43.0028 51.9096 40.8828 52.9899C38.4724 54.218 35.3172 54.218 29.0069 54.218H19.993C13.6826 54.218 10.5275 54.218 8.11709 52.9899C5.99709 51.9096 4.2734 50.186 3.19314 48.066C1.96507 45.6556 1.96507 42.5004 1.96507 36.1901ZM38.5842 14.782H10.4156V28.8663C10.4156 31.9778 12.9379 34.5 16.0494 34.5H32.9505C36.062 34.5 38.5842 31.9778 38.5842 28.8663V14.782ZM16.0494 44.359C16.0494 46.6925 14.1576 48.5843 11.8241 48.5843C9.49059 48.5843 7.59879 46.6925 7.59879 44.359C7.59879 42.0255 9.49059 40.1337 11.8241 40.1337C14.1576 40.1337 16.0494 42.0255 16.0494 44.359ZM37.1758 48.5843C39.5093 48.5843 41.4011 46.6925 41.4011 44.359C41.4011 42.0255 39.5093 40.1337 37.1758 40.1337C34.8423 40.1337 32.9505 42.0255 32.9505 44.359C32.9505 46.6925 34.8423 48.5843 37.1758 48.5843Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTram);
export default __webpack_public_path__ + "static/media/tram.77f340c59d05c9fa20142287e13e08d2.svg";
export { ForwardRef as ReactComponent };